module.exports = __webpack_public_path__ + "img/ZHXH.8fdc8176.png";